// src/pages/Values.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  .container { 
    width: min(1400px, 96vw); 
    margin: 0 auto; 
    padding: 0 18px; 
  }
`;

const Content = styled.div`
  padding: 40px 0;
  
  h1 {
    font-size: clamp(32px, 5vw, 48px);
    margin-bottom: 30px;
    color: var(--fg);
    text-align: center;
  }
  
  .values-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    margin: 40px 0;
  }
  
  .value-card {
    background: var(--card);
    border: 1px solid var(--bdr);
    border-radius: var(--radius);
    padding: 30px;
    box-shadow: var(--shadow);
    
    h3 {
      color: var(--primary);
      margin-bottom: 15px;
      font-size: 22px;
    }
    
    p {
      color: var(--muted);
      line-height: 1.6;
      margin: 0;
      font-size: 16px;
    }
  }
  
  @media (max-width: 768px) {
    padding: 20px 0;
    
    .values-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .value-card {
      padding: 20px;
      
      h3 {
        font-size: 20px;
      }
    }
  }
`;

export default function Values() {
  const { t } = useTranslation();

  const values = [
    {
      title: t('values.professionalism', 'Профессионализм'),
      description: t('values.professionalismDesc', 'Высокий уровень экспертизы и компетенций в области недвижимости, постоянное развитие и совершенствование навыков.')
    },
    {
      title: t('values.integrity', 'Честность'),
      description: t('values.integrityDesc', 'Прозрачность во всех деловых отношениях, честная оценка объектов и открытое информирование клиентов.')
    },
    {
      title: t('values.clientFocus', 'Клиентоориентированность'),
      description: t('values.clientFocusDesc', 'Индивидуальный подход к каждому клиенту, понимание его потребностей и предоставление персонализированных решений.')
    },
    {
      title: t('values.innovation', 'Инновации'),
      description: t('values.innovationDesc', 'Использование современных технологий и методов работы для повышения качества обслуживания клиентов.')
    },
    {
      title: t('values.reliability', 'Надежность'),
      description: t('values.reliabilityDesc', 'Выполнение всех обязательств в срок, стабильность и предсказуемость в работе с клиентами и партнерами.')
    },
    {
      title: t('values.excellence', 'Стремление к совершенству'),
      description: t('values.excellenceDesc', 'Постоянное улучшение качества услуг и поиск новых возможностей для развития бизнеса.')
    }
  ];

  return (
    <Container>
      <div className="container">
        <Content>
          <h1>{t('values.title', 'Корпоративные ценности')}</h1>
          
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </Content>
      </div>
    </Container>
  );
}